import React from 'react';

import { Choice, Group, Toggle } from './OptionControls';

/**
 * The decisions section's options: the lowest priority the decisions required
 * and made tables list, and whether the page shows the overdue actions on
 * those decisions.
 */
const DecisionsOptions = ({ options, readOnly, onChange }) => {
    const set = (changes) => onChange({ ...options, ...changes });

    return (
        <div className="tw-flex tw-flex-col tw-mt-3 tw-ps-4 tw-border-s-2 tw-border-charcoal-15">
            <Group title={$t('Decisions')}>
                <Choice
                    id="mp-decisions-rating"
                    label={$t('Decisions required and made')}
                    value={options.min_rating}
                    choices={[
                        { value: 'high', label: $t('High only') },
                        { value: 'medium', label: $t('High and medium') },
                        { value: 'all', label: $t('All') },
                    ]}
                    disabled={readOnly}
                    onChange={(value) => set({ min_rating: value })}
                />
                <Toggle
                    label={$t('Overdue actions')}
                    hint={$t('Actions on the decisions listed')}
                    checked={!!options.show_overdue_actions}
                    disabled={readOnly}
                    onChange={() => set({ show_overdue_actions: !options.show_overdue_actions })}
                />
            </Group>
        </div>
    );
};

export default DecisionsOptions;
